// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1syy9","fullView":"styles_fullView__3PSrr"};